export default "__VITE_ASSET__48238c05__"